import { queryOptions, useQuery } from '@tanstack/react-query'

import { communityApi } from '../../community/api/communityApi'

export const getTagQueryOptions = (tag: string, enabled: boolean = true) =>
  queryOptions({
    queryKey: ['tag', tag],
    enabled,
    queryFn: ({ signal }) => communityApi.getTag(tag, { signal }),
  })

export const useTagQuery = (tag: string, enabled?: boolean) => useQuery(getTagQueryOptions(tag, enabled))
